import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

export const SOURCE_MAP = {
  team:                 { getValue: (p)         => p.teams?.split(';')[0],                                             evaluationKey: 'teams' },
  teams:                { getValue: (p)         => p.teams.split(';').join('/'),                                       evaluationKey: 'teams' },
  state:                { getValue: (p)         => p.states?.split(';')[0],                                            evaluationKey: 'states' },
  states:               { getValue: (p)         => p.states.split(';').join('/'),                                      evaluationKey: 'states' },
  positions:            { getValue: (p)         => p.positions,                                                        evaluationKey: 'positions' },
  number:               { getValue: (p)         => p.numbers ? '#' + p.numbers.split(';')[0] : '',                     evaluationKey: 'numbers' },
  numbers:              { getValue: (p)         => p.numbers ? '#' + p.numbers.split(';').join('/') : '',              evaluationKey: 'numbers' },
  career_games:         { getValue: (p)         => p.career_games,                                                     evaluationKey: 'games' },
  debut_year:           { getValue: (p)         => p.debut_year,                                                       evaluationKey: 'debut_year' },
  age:                  { getValue: (p)         => p.age != null ? p.age + 'y' : '',                                   evaluationKey: 'age' },
  other_teams:          { getValue: (p, code)   => p.teams?.split(';').filter(t => t !== code).join('/') || '-',       evaluationKey: 'other_teams' },
  'club_stats.numbers': { getValue: (p, code)   => { const e = p.club_stats?.find(s => s.team === code); return e?.numbers?.length ? '#' + e.numbers.join('/') : ''; }, showArrow: (value) => !value.includes('/'), evaluationKey: 'club_numbers' },
  'club_stats.games':   { getValue: (p, code)   => p.club_stats?.find(s => s.team === code)?.games,                    evaluationKey: 'club_games' },
  'club_stats.debut':   { getValue: (p, code)   => p.club_stats?.find(s => s.team === code)?.years?.[0],               evaluationKey: 'club_debut' },
};

const EMPTY_EVALUATION = { result: 0, higher: null };

const ClueArrow = (props) => {
  const style = { width: 0, height: 0, borderLeft: '5px solid transparent', borderRight: '5px solid transparent' };

  if (props.higher) {
    style.borderBottom = '5px solid black';
  } else {
    style.borderTop = '5px solid black';
  }

  return <Box sx={style} />;
};

const GuessRow = ({ value, evaluation, showArrow, xs }) => {
  let color = 'default';
  if (evaluation.result === 1) {
    color = 'warning';
  } else if (evaluation.result === 2) {
    color = 'success';
  }

  let label = (<Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5} sx={{ padding: 0, pt: 0.5, pb: 0.5 }}>
    <Typography variant="caption">{value}</Typography>
    {showArrow && evaluation.higher !== null && <ClueArrow higher={evaluation.higher} />}
  </Stack>);

  return (
    <Grid item xs={xs}>
      <Chip sx={{ display: "flex", borderRadius: 0, height: '100%', '.MuiChip-label': { padding: 0 }, padding: 0 }} label={label} color={color} />
    </Grid>
  );
};

const Guess = ({ guess, guessNo, correct, columns, gameTeamCode }) => {
  const xs = 12 / columns.length;
  return (
		<Paper variant="outlined" sx={{ p: 1.5, borderColor: correct ? 'var(--correct-border, green)' : 'var(--guess-border, transparent)', backgroundColor: correct && 'var(--correct-bg, rgba(0, 255, 0, 0.1))' }}>
			<Stack direction="column" spacing={0.5}>
				<Typography variant="subtitle2" sx={{ color: correct && 'var(--correct-text, green)' }}>{`${guessNo}. ${guess.name}`}</Typography>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={0.5}>
            {columns.map(col => {
              const mapping = SOURCE_MAP[col.source] || { getValue: () => '', evaluationKey: col.source };
              const value = guess ? mapping.getValue(guess, gameTeamCode) : '';
              const evaluation = guess?.evaluation?.[mapping.evaluationKey] ?? EMPTY_EVALUATION;
              const showArrow = mapping.showArrow ? mapping.showArrow(value) : true;
              return <GuessRow key={col.key} value={value} evaluation={evaluation} showArrow={showArrow} xs={xs} />;
            })}
          </Grid>
        </Box>
			</Stack>
		</Paper>
	);
};

export default Guess;
